<template>
  <v-dialog :value="value" persistent max-width="432px" attach="#modal-portal">
    <v-card class="mx-auto">
      <v-toolbar dark color="primary" height="45">
        <v-toolbar-title>Send Expiry Option Repot</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn small icon color="primary" @click="closeForm"><v-icon>close</v-icon></v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-form @submit.prevent="sendExpiryOptionReport" ref="form">
          <v-card>
            <v-container fluid grid-list-sm class="py-2">
              <v-bottom-nav
                :active.sync="sendFormat"
                :value="true"
                color="#fff"
                style="box-shadow:0px 0px #fff"
              >
                <v-btn color="green" flat :value="1">
                  <span>Excel</span>
                  <i class="k-icon k-i-excel"></i>
                </v-btn>
                <v-btn color="red" flat :value="2">
                  <span>PDF</span>
                  <i class="k-icon k-i-pdf"></i>
                </v-btn>
              </v-bottom-nav>
              <v-text-field
                v-model="sendTo"
                type="email"
                label="To:"
                required
                :rules="[v => !!v || 'Email is required']"
              ></v-text-field>
              <v-text-field v-model="sendCc" type="email" label="CC:"></v-text-field>
              <v-text-field v-model="sendSubject" type="text" label="Subject:"></v-text-field>
              <v-textarea v-model="sendComments" label="Comments" counter="256"></v-textarea>
              <v-switch v-model="sendMeCopy" label="Send me a copy" />
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn type="submit" color="blue primary" :disabled="sending">
                  <v-progress-circular indeterminate v-if="sending" />
                  Send
                </v-btn>
              </v-card-actions>
            </v-container>
          </v-card>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from 'axios'
import notification from '@/helpers/notification'

export default {
  props: {
    value: {type: Boolean},
    clientId: {type: Number},
    lastParams: {type: Object},
  },
  data() {
    return {
      sending: false,
      sendFormat: 2,
      sendTo: '',
      sendCc: 'trading2@finmetrix.com',
      sendSubject: 'Expiry Option Report',
      sendComments: '',
      sendMeCopy: false,
    }
  },
  computed: {
    ticketMethodUrl() {
      return '/api/report/ExposureReport/sendExpiryOptionReport'
    },
  },
  methods: {
    async sendExpiryOptionReport(e) {
      this.sending = true
      let formData = new FormData(e.target)
      formData.append('asOfDate', this.lastParams.asOfDate)
      formData.append('clientId', +this.clientId)
      formData.append('responsibleEmail', this.lastParams.responsibleEmail)
      formData.append('analystEmail', this.lastParams.analystEmail)
      formData.append('reconciledClient', this.lastParams.reconciledClient)
      formData.append('sendFormat', this.sendFormat)
      formData.append('sendTo', this.sendTo)
      formData.append('sendCc', this.sendCc)
      formData.append('sendSubject', this.sendSubject)
      formData.append('sendComments', this.sendComments)
      formData.append('sendMeCopy', this.sendMeCopy)
      formData.append('url', location.origin)

      const response = await axios({
        url: this.ticketMethodUrl,
        method: 'post',
        data: formData,
        headers: {'Content-Type': 'multipart/form-data'},
      }).catch(() => {
        notification('Some error', 'error')
        this.sending = false
      })

      if (response.status == 200) {
        notification('Report sent successfully')
      }

      this.closeForm()
    },
    async getClientData() {
      const req = await axios
        .get('/api/config/client/getClient', {
          params: {
            clientId: +this.clientId,
            t: new Date().getTime(),
          },
        })
        .catch(() => notification('Error ', 'error'))
      let data = req.data
      this.sendTo = data.email
      this.sendSubject = `${this.lastParams.asOfDate} Expiry Option Report`
    },
    closeForm() {
      this.$emit('input', false)
    },
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.getClientData()
        this.sendCc = 'trading2@finmetrix.com'
        this.sendSubject = 'Expiry Option Report'
        this.sendComments = ''
        this.sendMeCopy = false
        this.sending = false
        this.sendFormat = 2
      }
    },
  },
}
</script>
